module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/DE-587fadc34b90ec1e076936dd7cde2731.png";